import api from "./client"
import type { Membership } from "../types"

export async function getMemberships(): Promise<Membership[]> {
  const { data } = await api.get<Membership[]>("/memberships")
  return data
}

export async function createMembership(params: Record<string, unknown>): Promise<Membership> {
  const { data } = await api.post<Membership>("/memberships", { membership: params })
  return data
}

export async function updateMembership(id: number, params: Record<string, unknown>): Promise<Membership> {
  const { data } = await api.patch<Membership>(`/memberships/${id}`, { membership: params })
  return data
}
